Array.prototype.contain = function (item) {
  if (this.indexOf(item) > -1) {
    return true
  } else {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/ext.js